import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export const syncQueueSchemaLiteral = {
  title: 'sync_queue',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    collection_name: { type: 'string', maxLength: 50 },
    action: { type: 'string', maxLength: 20 },
    updated_at: { type: 'string', maxLength: 50 },
  },
  required: ['id', 'collection_name', 'action'],
} as const;

const schemaTyped = toTypedRxJsonSchema(syncQueueSchemaLiteral);
export type SyncQueueDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const syncQueueSchema: RxJsonSchema<SyncQueueDocType> = syncQueueSchemaLiteral as any;
